<template>
  <div class="bg-primary/5 border-primary-light border-t pt-8 pb-1">
    <NuxtLayout name="center">
      <BlogCategory
        v-if="props.displayCategory"
        :categoryLists="catLists"
        @emit-category-id="updateCategoryTab"
      ></BlogCategory>
      <div class="flex flex-wrap ease-in duration-300">
        <TransitionRoot
          appear
          v-for="(allBlog, index) in allBlogs"
          :key="index"
          :show="true"
          class="blog-card basis-full md:basis-1/2 lg:basis-1/3 mb-8"
          enter="transition-opacity duration-300"
          enter-from="opacity-0"
          enter-to="opacity-100"
          leave="transition-opacity duration-300"
          leave-from="opacity-100"
          leave-to="opacity-0"
        >
          <BlogListing :data="allBlog"></BlogListing>
        </TransitionRoot>
      </div>
      <div class="grid gap-x-20 gap-y-4 md:grid-cols-3" v-if="!isShowing">
        <BlogSkeleton v-for="n in 3" :key="n"></BlogSkeleton>
      </div>
      <div class="flex justify-center my-16 font-bold text-secondary">
        <div>{{ errorMessage }}</div>
        <button
          class="border rounded px-10 py-1 border-secondary"
          @click="loadMore"
          v-if="!pending && !errorMessage && allBlogs.length < totalBlogs"
        >
          {{ $t("blog.pagination") }}
        </button>
      </div>
    </NuxtLayout>
  </div>
</template>

<script setup>
import { TransitionRoot } from "@headlessui/vue";
import { useGlobalStore } from "~/stores/global";

const props = defineProps({
  displayCategory: {
    type: Boolean,
    default: false,
  },
  author: {
    type: Number,
    default: 0,
  },
  category: {
    type: Number,
    default: 0,
  },
  tag: {
    type: Number,
    default: 0,
  },
});

const globalStore = useGlobalStore();
const site = () => globalStore.siteCurrentLocale;

const allCategory = ref("all");
const categoryId = shallowRef(0);
const catLists = ref([]);
const paged = shallowRef(1);
const allBlogs = ref([]);
const totalBlogs = shallowRef(0);

const queryString = computed(() => {
  let values = `?paged=${paged.value}&posts_per_page=${globalStore.siteSettings.blogs_per_page}`;
  values += `&orderby=date&order=DESC`;
  if (props.category != 0) {
    categoryId.value = props.category;
  }
  if (categoryId.value != 0 && categoryId.value != "all") {
    values += `&cat=${categoryId.value}`;
  }
  if (props.author != 0) {
    values += `&author=${props.author}`;
  }
  if (props.tag != 0) {
    values += `&tag=${props.tag}`;
  }
  return values;
});
const { data: blogLists, pending, error: errorMessage, refresh } = await useBlogList(queryString, site);
if (import.meta.client && !blogLists.value?.data) await refresh();
watch(
  blogLists,
  () => {
    (allBlogs.value =
      blogLists.value?.data?.length > 0 ? [...allBlogs.value, ...blogLists.value.data] : allBlogs.value),
      (totalBlogs.value = blogLists.value?.total ?? 0);
  },
  { immediate: true }
);
watch(
  () => queryString.value,
  () => {
    errorMessage.value = "";
    refresh();
  }
);

const isShowing = ref(true);
function loadMore() {
  paged.value++;
}

if (props.displayCategory) {
  const { t } = useI18n();
  const { data: categoryLists, refresh: refreshCategoryLists } = await useCategoryList(site);
  if (import.meta.client && !categoryLists.value?.data) await refreshCategoryLists();
  catLists.value = [...[{ name: t("blog.allCategories"), category_id: "all" }], ...(categoryLists.value?.data ?? [])];
}

var selectedId = allCategory.value;
function updateCategoryTab(id) {
  if (id == selectedId) {
    return;
  }
  selectedId = id;
  isShowing.value = false;
  setTimeout(() => {
    isShowing.value = true;
  }, 1000);
  paged.value = 1;
  allBlogs.value = [];
  categoryId.value = id;
}
</script>

<style scoped>
.blog-card:nth-child(even) {
  @apply md:pl-8 lg:pl-0;
}
.blog-card:nth-child(odd) {
  @apply md:pr-8 lg:pr-0;
}
.blog-card:nth-child(3n + 2) {
  @apply lg:px-7;
}
.blog-card:nth-child(3n + 1) {
  @apply lg:pr-14;
}
.blog-card:nth-child(3n) {
  @apply lg:pl-14;
}
</style>
